import { render, staticRenderFns } from "./RelationsSearch.vue?vue&type=template&id=3ecc29f6&scoped=true"
import script from "./RelationsSearch.vue?vue&type=script&lang=js"
export * from "./RelationsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc29f6",
  null
  
)

export default component.exports